import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import styled from 'styled-components';
import { PageHeading } from 'foundations-components/transitional/components/PageHeading';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Paragraph = styled.p.withConfig({
  displayName: "ViewProgressState__Paragraph",
  componentId: "k3uc92-0"
})(["max-inline-size:540px;text-align:center;"]);
function ViewProgressState({
  showEmptyThreadToolbar = true
}) {
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "100%",
    children: [showEmptyThreadToolbar && /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-default",
      blockSize: "60px",
      borderBlockEndColor: "border-core-subtle",
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: "100"
    }), /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "start",
      alignItems: "center",
      flexDirection: "column",
      inlineSize: "100%",
      marginBlockStart: "1300",
      paddingInline: "1000",
      children: [/*#__PURE__*/_jsx(Illustration, {
        name: "building",
        width: "200px",
        "data-test-id": "view-progress-state"
      }), /*#__PURE__*/_jsx(PageHeading, {
        marginBlock: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "svh-workspace-ui-lib.custom-views.progressStates.building.title"
        })
      }), /*#__PURE__*/_jsx(Paragraph, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "svh-workspace-ui-lib.custom-views.progressStates.building.paragraph"
        })
      }), /*#__PURE__*/_jsxs(Text, {
        as: "small",
        textAlign: "center",
        children: [/*#__PURE__*/_jsx(StatusDot, {
          use: "warning"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "svh-workspace-ui-lib.custom-views.progressStates.building.progress"
        })]
      })]
    })]
  });
}
ViewProgressState.displayName = 'ViewProgressState';
export default ViewProgressState;